import { useEffect } from "react";
import loadBackboneApp from "../../../../app/load-backbone-app";
import api from "../../../../core/api/api";
import { SetupView } from "../../../../app/components/alertmanager/alertmanager";
import { ALERT_TYPE } from "../../../../app/components/alertmanager/alert-utils";
import AlertManagerRoot from "../alert-manager-root";

function TeamsSetup() {
    useEffect(() => {
        api.getTeamsConfigStatus()
            .then(teamsConfigStatus => {
                if (teamsConfigStatus === "TEAMS_CONFIGURED") {
                    api.getTeamsConfig().then(res => {
                        loadBackboneApp(
                            // @ts-ignore
                            new SetupView({
                                type: ALERT_TYPE.TEAMS,
                                existingConfigDtls: res || null
                            })
                        );
                    });
                } else {
                    loadBackboneApp(
                        // @ts-ignore
                        new SetupView({
                            type: ALERT_TYPE.TEAMS,
                            existingConfigDtls: null
                        })
                    );
                }
            })
            .fail(() => {
                console.error("Error retrieving Teams configuration status");
            });
    }, []);

    return <></>;
}

export default function() {
    return (
        <AlertManagerRoot>
            <TeamsSetup />
        </AlertManagerRoot>
    );
}
